export const getPlayedTime = (playedTimeRanges, startSec) => {
  let playedTime = 0;
  for (let index = 0; index < playedTimeRanges.length; index++) {
    const playedTimeRange = playedTimeRanges.end(index) - playedTimeRanges.start(index);
    playedTime += playedTimeRange;
  }
  if (startSec && playedTime >= startSec) {
    return playedTime - startSec;
  }
  return playedTime;
};
